import React, { useContext } from "react";
import { observer } from "mobx-react";

import { OfferStoreContext } from "@gp/components";

import { useRootAppStore } from "@hooks";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { analyticsTracker } from "@utils/analytics";

export const EventSwitcherButton = observer(function EventSwitcherButton({
	eventId,
	direction,
}: {
	eventId: string;
	direction: "left" | "right";
}) {
	const store = useContext(OfferStoreContext) as EventViewStore;
	const { eventSwitcherViewStore } = useRootAppStore();

	if (
		!eventSwitcherViewStore.isAvailable ||
		store.multiEventViewStore?.eventsViewMap.size !== 1
	) {
		return null;
	}

	const { moveLeft, moveRight } = eventSwitcherViewStore;
	const action = direction === "left" ? moveLeft : moveRight;

	return (
		<button
			className={
				"event__arrow event__arrow--" +
				direction +
				" btn btn--square btn--square--sml btn--primary--inverted"
			}
			type="button"
			onClick={() => {
				action(eventId);
				analyticsTracker.trackLiveEventSwitcherInteraction(
					direction === "left" ? "previous" : "next"
				);
			}}
		>
			<i className={"u-icon u-icon--tny u-icon--arrow-" + direction} />
		</button>
	);
});
